import { concat } from '../data/concat.js';
import { toBytes } from '../encoding/toBytes.js';
import { keccak256 } from '../hash/keccak256.js';
export function hashMessage(message, to_) {
    const messageBytes = toBytes(message);
    const prefixBytes = toBytes(`\x19Ethereum Signed Message:\n${messageBytes.length}`);
    return keccak256(concat([prefixBytes, messageBytes]), to_);
}
//# sourceMappingURL=hashMessage.js.map